import {NgModule} from '@angular/core';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {HomeComponent} from './home/home.component';
import {LayoutModule} from "./layout/layout.module";
import {TranslateLoader, TranslateModule} from "@ngx-translate/core";
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from "@angular/common/http";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {GeolocationComponent} from "./views/geolocation/geolocation.component";
import {LoginComponent} from "./components/login/login.component";
import {LoginTokenComponent} from "./components/login-token/login-token.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {PasswordModule} from "primeng/password";
import {Wso2formComponent} from "./components/wso2form/wso2form.component";
import {ContractService} from "./lib/services/contracts/contract.service";
// import { AuthGuard } from "./core/guard/auth.guard";
import {HIGHLIGHT_OPTIONS} from "ngx-highlightjs";
import {InactivityModalComponent} from "./components/inactivity-modal/inactivity-modal.component";
/* interceptors */
import {RequestInterceptor} from "./lib/interceptos/request-interceptor";
import {ErrorInterceptor} from "./lib/interceptos/error-interceptor";

import {JWT_OPTIONS, JwtModule} from "@auth0/angular-jwt";
import {StorageKeysEnum} from "./lib/storage/storage-keys.enum";
import {TokenUnlockComponent} from "./views/token-unlock/token-unlock.component";
import {UserBlockedModalComponent} from "./components/user-blocked-modal/user-blocked-modal.component";
import {MessageService} from "primeng/api";
import {
    TokenCancelAuthorizationComponent
} from "./components/token-cancel-authorization/token-cancel-authorization.component";
import {TokenCancelComponent} from "./components/token-cancel/token-cancel.component";
import {TokenCancelSuccessComponent} from "./components/token-cancel-success/token-cancel-success.component";
import {CodeInputModule} from "angular-code-input";
import {AccessDisabledComponent} from "./components/access-disabled/access-disabled.component";
import {TokenUnlockedSuccessComponent} from "./components/token-unlocked-success/token-unlocked-success.component";
import {ValidateDataComponent} from './components/restore-password/validate-data.component';
import {ResetPasswordService} from './lib/services/reset-password/reset-password.service';
import {ResetPasswordComponent} from './components/reset-password/reset-password.component';
import {GenericModalComponent} from './components/generic-modal/generic-modal.component';
import {GenericModalService} from './lib/services/generic-modal/generic-modal.service';
import {DashboardComponent} from './views/dashboard/dashboard.component';
import {FileUploadModule} from 'primeng/fileupload';

import {environment} from '../environments/environment';
import {ConsultaDinamicaComponent} from './components/consulta-dinamica/consulta-dinamica.component';
import {WelcomeComponent} from './components/welcome/welcome.component';
import {FeedbackComponent} from './components/feedback/feedback.component';
import {FeedbackFormComponent} from './components/feedback-form/feedback-form.component';
import {ProfileImageComponent} from './components/profile-image/profile-image.component';
import {AvatarModule} from "primeng/avatar";
import {ImageCropperModule} from "ngx-image-cropper";
import {ToastModule} from "primeng/toast";
import {StoreDevtoolsModule} from '@ngrx/store-devtools';
import {StoreModule} from '@ngrx/store';
import {ModalsComponent} from './components/modals/modals.component';
import {ModalsService} from './lib/services/modals/modals.service';
import {NotificationConnectionService} from './lib/services/notifications/notification-connection.service';
import {CarouselModule} from 'primeng/carousel';
import {LoadingService} from './lib/services/loading/loading.service';
import {
    ContractInformationModalComponent
} from './components/contract-information-modal/contract-information-modal.component';
import {ContractDeatilsModalService} from './lib/services/dashboard/contract-details-modal.service';
import {CheckZeroPipe} from './lib/pipes/check-zero.pipe';
import {DialogModule} from 'primeng/dialog'
import {ProgressSpinnerModule} from "primeng/progressspinner";
import {NpsComponent} from "./components/nps/nps.component";
import {InputTextareaModule} from "primeng/inputtextarea";
import {InputTextModule} from "primeng/inputtext";
import {NpsLogoutComponent} from './components/nps-logout/nps-logout.component';
import {CurrencyConverterPipe} from "./lib/pipes/currency-converter.pipe";
import {PaymentLiberationComponent} from './components/payment-liberation/payment-liberation.component';
import {MonexUltra2Component} from './components/monex-ultra/monex-ultra2.component';
import { GeolocationModalComponent } from './components/geolocation-modal/geolocation-modal.component';
import { ChangeTemporalPasswordComponent } from './components/change-temporal-password/change-temporal-password.component'
import { PermissionService } from './lib/services/permission/permission.service';
import {TooltipModule} from "primeng/tooltip";
import { PhraseAndImageRegisterModalComponent } from './components/phrase-and-image-register-modal/phrase-and-image-register-modal.component';
import {PaginatorModule} from "primeng/paginator";
import { PhraseImgSuccessComponent } from './components/phrase-img-success/phrase-img-success.component';
import {NgIf, NgOptimizedImage} from "@angular/common";
import {
    PendingAuthorizationsModalComponent
} from "./components/pending-authorizations-modal/pending-authorizations-modal.component";
import {NuevaBancaLibraryModule} from "@monex-sistemas/nueva-banca-digital-library";
import { DiscoverYourBankComponent } from './components/discover-your-bank/discover-your-bank.component';
import {NgbDropdown, NgbDropdownItem, NgbDropdownMenu} from "@ng-bootstrap/ng-bootstrap";
import {AccordionModule} from "primeng/accordion";

@NgModule({
    declarations: [
        AppComponent,
        HomeComponent,
        GeolocationComponent,
        LoginComponent,
        LoginTokenComponent,
        Wso2formComponent,
        InactivityModalComponent,
        TokenUnlockComponent,
        UserBlockedModalComponent,
        TokenCancelAuthorizationComponent,
        TokenCancelComponent,
        TokenCancelSuccessComponent,
        AccessDisabledComponent,
        TokenUnlockedSuccessComponent,
        ValidateDataComponent,
        ResetPasswordComponent,
        GenericModalComponent,
        DashboardComponent,
        ConsultaDinamicaComponent,
        WelcomeComponent,
        FeedbackComponent,
        FeedbackFormComponent,
        ProfileImageComponent,
        ModalsComponent,
        ContractInformationModalComponent,
        CheckZeroPipe,
        NpsComponent,
        NpsLogoutComponent,
        CurrencyConverterPipe,
        PaymentLiberationComponent,
        GeolocationModalComponent,
        ChangeTemporalPasswordComponent,
        PendingAuthorizationsModalComponent,
        ChangeTemporalPasswordComponent,
        PhraseAndImageRegisterModalComponent,
        PhraseImgSuccessComponent,
        DiscoverYourBankComponent
    ],
    imports: [
        AppRoutingModule,
        LayoutModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: httpTranslateLoader,
                deps: [HttpClient]
            }
        }),
        HttpClientModule,
        DialogModule,
        BrowserAnimationsModule,
        ReactiveFormsModule,
        PasswordModule,
        JwtModule.forRoot(
            {
                jwtOptionsProvider: {
                    provide: JWT_OPTIONS,
                    useFactory: jwtOptionsFactory
                }
            }
        ),
        CarouselModule,
        CodeInputModule,
        AvatarModule,
        FileUploadModule,
        ImageCropperModule,
        ToastModule,
        StoreModule.forRoot({}, {}),
        StoreDevtoolsModule.instrument({name: "Banca Digital", logOnly: environment.production}),
        ProgressSpinnerModule,
        DialogModule,
        InputTextareaModule,
        InputTextModule,
        FormsModule,
        TooltipModule,
        DialogModule,
        NgIf,
        TranslateModule,
        TooltipModule,
        PaginatorModule,
        NuevaBancaLibraryModule,
        NuevaBancaLibraryModule,
        NgbDropdown,
        NgbDropdownItem,
        NgbDropdownMenu,
        AccordionModule,
        NgOptimizedImage
    ],
    providers: [
        ResetPasswordService,
        GenericModalService,
        ContractService,
        LoadingService,
        ContractDeatilsModalService,
        // AuthGuard,
        ModalsService,
        {provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true},
        {provide: HTTP_INTERCEPTORS, useClass: RequestInterceptor, multi: true},
        {
            provide: HIGHLIGHT_OPTIONS, // https://www.npmjs.com/package/ngx-highlightjs
            useValue: {
                coreLibraryLoader: () => import('highlight.js/lib/core'),
                languages: {
                    xml: () => import('highlight.js/lib/languages/xml'),
                    typescript: () => import('highlight.js/lib/languages/typescript'),
                    scss: () => import('highlight.js/lib/languages/scss'),
                }
            }
        },
        MessageService,
        NotificationConnectionService,
        PermissionService
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}

export function httpTranslateLoader(http: HttpClient) {
    const env = environment.homeUrl
    return new TranslateHttpLoader(http, `${env}/assets/i18n/`, '.json');
}

export function jwtOptionsFactory() {
    return {
        tokenGetter: () => sessionStorage.getItem(StorageKeysEnum.ACCESS_TOKEN),
        allowedDomains: ['localhost:8085', 'nbd-gateway-bdm.apps.monex-dev.southcentralus.aroapp.io', /.*:8085*./, /.*gateway*./],
        disallowedRoutes: [/.*refresh*/],
    };
}
